export const AUTH_STATES = {
  SIGNED_IN: 'signedIn',
  SIGNED_UP: 'signedUp',
  SIGN_UP: 'signUp',
  SIGN_IN: 'signIn',
  CONFIRM_SIGN_UP: 'confirmSignUp',
  CONTACT_US: 'contactUs',
  DESKTOP_ONLY_MODAL: 'modalRestricted',
  CONFIRM_PAGE_CHANGE_MODAL: 'confirmPageChange',
  FORGOT_PASSWORD: 'forgotPassword',
  CONFIRM_SIGN_IN: 'confirmSignIn',
  REQUIRE_NEW_PASSWORD: 'requireNewPassword',
  VERIFY_CONTACT: 'verifyContact',
} as const;

type AuthStateKeys = keyof typeof AUTH_STATES;
export type AuthStateTypes = typeof AUTH_STATES[AuthStateKeys];

export const GetAuthStateTitleMap = (name: string) => ({
  [AUTH_STATES.SIGN_IN]: 'Sign In',
  [AUTH_STATES.SIGN_UP]: `Sign up for ${name}`,
  [AUTH_STATES.CONTACT_US]: 'Contact Us',
  [AUTH_STATES.DESKTOP_ONLY_MODAL]: 'Mobile support coming soon',
});

export const GetContactText = (name: string, email: string) =>
  `If you are interested in doing a campaign with ${name}, please contact us at ${email}`;

export const GetSignUpText = (name: string) =>
  `If you are interested in doing a campaign with ${name}, please create an account with us.`;

export const GetMobileRestrictedDescription = (name: string) =>
  `The ${name} Portal does not support all functionality on mobile devices yet. Please switch to a desktop device.`;

export const MFA_CODE_LENGTH = 6;

export const MFA_INPUT_TITLE = "Verify it's you";

export const MFA_INPUT_DESCRIPTION =
  'Please enter your code from your authenticator app.';

export const MFA_ISSUER_NAME = 'Copilot.com';

export const SESSION_EXPIRY_ERR_MSG =
  'Session expired. Please refresh and try logging in again.';

export const INVALID_CODE = 'Invalid code';
